var Enum = Enum || { MEEDY : {}};

Enum.MEEDY.APPOINTMENT_STATUS = {
    PRERESERVATION: 'PRERESERVATION',
    RESERVATION: 'RESERVATION',
    CANCELLATION: 'CANCELLATION',
    DONE: 'DONE',
    CANCELLATION_BY_MEDICAL_POST_TO_REORGANIZE: 'CANCELLATION_BY_MEDICAL_POST_TO_REORGANIZE',
    CANCELLATION_BY_MEDICAL_POST_DONE: 'CANCELLATION_BY_MEDICAL_POST_DONE',
    CANCELLATION_BY_CUSTOMER: 'CANCELLATION_BY_CUSTOMER',
    ALL: 'ALL' //only for filtering
};

Object.freeze(Enum.MEEDY.APPOINTMENT_STATUS);